import { applyEditTrackingFields } from "./applyEditTrackingFields";
import { castDateFields } from "./castDateFields";
import { castDateToFireStoreDate } from "./castDateToFireStoreDate";
import { firestoreAutoId } from "./firestoreAutoId";
import { getMaxNo } from "./getMaxNo";
import { saveFileChanges } from "./saveFileChanges";
import { saveToFirestore } from "./saveToFirestore";
import { updateStorageInFirestore } from "./updateStorageInFirestore";

export async function onEditSaveAll(
  project,
  feat,
  editSchema,
  editFiles,
  tableName,
  relatedableId,
  user,
) {
  //convert date fields
  feat = applyEditTrackingFields(feat, user);
  const newFeat = castDateFields(feat, editSchema);
  const newEditFeature = castDateToFireStoreDate({ ...newFeat });
  newEditFeature.fileCount = editFiles.filter(
    (f) => f.deleted === false,
  ).length;

  if (newEditFeature.id === "new") {
    newEditFeature.id = firestoreAutoId();
    newEditFeature.Selected = false;
    if (tableName !== "Comments") {
      newEditFeature.commentCount = 0;
    }
    if (tableName === "Observations") {
      newEditFeature.issueCount = 0;
    }

    newEditFeature.No = getMaxNo(project[tableName]);
    project[tableName].push({ ...newEditFeature });
  } else {
    const updatedArray1 = project[tableName].map((obj) => {
      if (obj.id === newEditFeature.id) {
        return newEditFeature; // Replace the object if its ID matches
      }
      return obj; // Keep other objects as they are
    });
    project[tableName] = updatedArray1;
  }

  editFiles.forEach((f) => {
    f[relatedableId] = newEditFeature.id;
  });

  //first save or delete any files
  const sfc = await saveFileChanges(editFiles, project.uid, project.id);

  //merge in new files with existing
  const projOtherFiles = project.Files.filter(
    (p) => p[relatedableId] !== newFeat.id,
  );
  project.Files = [
    ...projOtherFiles.concat(sfc.files.filter((f) => !f.deleted)),
  ];

  //replace base64 sigs
  if (tableName === "Checklists") {
    var chlist = project.Checklists.find((c) => c.id === newEditFeature.id);
    if (chlist !== undefined) {
      chlist.rows.forEach((r) => {
        if (
          r["Row Type"] === "Signature" &&
          r.value &&
          r.value.startsWith("data:image/png;base64,")
        ) {
          const file = sfc.files.find((f) => f.id === r.id);
          console.log(file);
          if (file) {
            r.value = file.file;
          }
        } else if (r["Row Type"] === "File" && r.value) {
          const file = sfc.files.find((f) => f.id === r.id);
          if (file) {
            r.value["url"] = file.file;
          }
        }
      });
    }
  } else if (tableName === "Issues") {
    project.issues_log.push(
      castDateToFireStoreDate({
        id: newEditFeature.id,
        Status: newEditFeature.Status,
        user: user.displayName.replace("Matt Miley", "Mike Miller"),
        uid: user.uid,
        date: new Date(),
      }),
    );
  }

  //Finally save the project
  await saveToFirestore("projects", project);
  //Save storage changes
  if (sfc.sizeChange !== 0) {
    await updateStorageInFirestore(user.uid, sfc.sizeChange);
  }

  return project;
}
